import AgogisUserResourceModel from '../../generated/types/model/resource/AgogisUserResourceModel';

export default class AgogisUserResourceViewModel extends AgogisUserResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
